var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconMySecurePractice = function SvgIconMySecurePractice(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 4.5L11.25 10.125L20.25 4.5V7.875H22.5V2.25C22.5 1.0125 21.4875 0 20.25 0H2.25C1.0125 0 0.01125 1.0125 0.01125 2.25L0 15.75C0 16.9875 1.0125 18 2.25 18H13.5V15.75H2.25V4.5ZM20.25 2.25L11.25 7.875L2.25 2.25H20.25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 12.375V11.8125C22.5 10.26 21.24 9 19.6875 9C18.135 9 16.875 10.26 16.875 11.8125V12.375C16.2562 12.375 15.75 12.8812 15.75 13.5V18C15.75 18.6187 16.2562 19.125 16.875 19.125H22.5C23.1188 19.125 23.625 18.6187 23.625 18V13.5C23.625 12.8812 23.1188 12.375 22.5 12.375ZM21.375 12.375H18V11.8125C18 10.8787 18.7538 10.125 19.6875 10.125C20.6213 10.125 21.375 10.8787 21.375 11.8125V12.375Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconMySecurePractice);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "icon-my-secure-practice.73a25fdbfceb7e06c96ec795a3188b19.svg";